module.exports = __webpack_public_path__ + "img/13.942e3a97.png";